<template>
	<popupLayout>
		<button type="button" class="bootbox-close-button close" data-dismiss="modal" aria-hidden="true" style="margin-top: -10px;" @click="$parent.showPopupControl(false);">×</button>
		<header class="text-center">
			<h3>&emsp;</h3>
		</header>
		<div class="bootbox-body">
			<section class="panel">
				<div class="panel-body">
					<div class="row form-group">
						<div class="col-md-6">
							<label class="col-md-4">已閱人數</label>
							<span class="col-md-6">{{readerCount}}</span>
						</div>
						<div class="col-md-6">
							<label class="col-md-4">未閱人數</label>
							<span class="col-md-6">{{nonReaderCount}}</span>
						</div>
					</div>
					<div class="row form-group">
						<div class="col-md-12">
							<label class="col-md-2">已閱名單</label>
							<div class="col-md-10">
								<span v-for="(item, index) in readerList" :key="index">
									{{item.name}}
								</span>&emsp;
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	</popupLayout>
</template>
<script>
import popupLayout from '../../popup/popupLayout';
export default {
	components:{
		popupLayout
	},
	props:["id"],
	data(){
		return {
			readerList:[],
			nonReaderCount:0,
			readerCount:0
		}
	},
	mounted(){
		const api = "/api/News/newsReader/"+this.id;
		this.$axios.post(api).then(resp =>{
			this.readerList = resp.data.data.readerList;
			this.nonReaderCount = resp.data.data.nonReaderCount;
			this.readerCount = resp.data.data.readerCount;
		});
	},
	methods:{

	}
}
</script>